"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderWeb = exports.renderMobile = exports.renderProgressionDay = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const checkProgressValue_1 = __importDefault(require("../recovery-week-overview/checkProgressValue"));
const typography_1 = require("../../shared/typography");
const styled_components_1 = __importDefault(require("styled-components"));
const Row_1 = __importDefault(require("./Row"));
const icons_1 = require("../../atoms/icons");
const renderMobile = (values, isProgress = false) => {
    const JSX = [];
    for (const [key, value] of values.entries()) {
        if (isProgress) {
            JSX.push((0, jsx_runtime_1.jsx)(Row_1.default, { title: key, value: value, isProgress: true }, key));
        }
        else {
            JSX.push((0, jsx_runtime_1.jsx)(Row_1.default, { title: key, value: value }, key));
        }
    }
    return JSX;
};
exports.renderMobile = renderMobile;
const renderWeb = (values) => {
    const titles = [];
    const progress = [];
    for (const [key, value] of values.entries()) {
        titles.push((0, jsx_runtime_1.jsx)(typography_1.P, { children: key }, key));
        progress.push((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", color: "light-grey", children: value || "-" }, void 0) }, key));
    }
    return ((0, jsx_runtime_1.jsxs)(WebWrapper, { children: [(0, jsx_runtime_1.jsx)("div", { children: titles }, void 0), (0, jsx_runtime_1.jsx)("div", { children: progress }, void 0)] }, void 0));
};
exports.renderWeb = renderWeb;
const WebWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  width: 100%;

  & > div {
    align-items: flex-end;
    display: flex;
    flex: 1;
  }

  & > div > p {
    color: ${({ theme }) => theme.colors.greyLighten40};
    flex: 1;
    margin: ${({ theme }) => `${theme.spacings.m} 0`};
    text-align: center;
  }

  & > div:last-of-type > div {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-bottom: ${({ theme }) => theme.spacings.m};
`;
const renderProgressionDay = (progression) => {
    return ((0, jsx_runtime_1.jsx)(Progression, { children: Array.from(progression.entries()).map(([key, value], idx) => {
            return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h4", { children: key }, void 0), idx === 0 ? ((0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", color: "light-grey", children: isNaN(parseInt(value.status)) ? "-" : value.status }, void 0)) : typeof value === "string" ? ((0, jsx_runtime_1.jsx)(SleptValueWrapper, { hasMargin: value.length > 1, children: (0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", color: "light-grey", children: value }, void 0) }, void 0)) : ((0, jsx_runtime_1.jsx)(D, { isRecommended: parseInt(value.status) >= 80, children: (0, checkProgressValue_1.default)(value.status, true) }, void 0)), (0, jsx_runtime_1.jsx)(typography_1.P, { children: value.reason }, void 0)] }, key));
        }) }, void 0));
};
exports.renderProgressionDay = renderProgressionDay;
const D = styled_components_1.default.div `
  & > div {
    background-color: ${({ theme }) => theme.colors.whiteBase};
    border-radius: ${({ theme }) => theme.utils.radius};
    width: unset;

    & > span {
      margin-left: ${({ isRecommended }) => isRecommended ? 0.25 : 1}rem;
      padding: ${({ theme }) => `0 ${theme.spacings.xs}`};
    }
  }
`;
const Progression = styled_components_1.default.div `
  padding: ${({ theme }) => `${theme.spacings.m} ${theme.spacings.xl}`};

  & > h4 {
    grid-area: title;
  }

  & > *:nth-of-type(2) {
    grid-area: value;
  }

  & > p {
    grid-area: reason;
  }

  p,
  h2 {
    color: ${({ theme }) => theme.colors.greyBase};
    margin-bottom: 0;
  }

  & > div {
    align-items: start;
    border-bottom: 1px solid
      ${({ theme }) => theme.colors.silverLighten70};
    display: grid;
    grid-template-columns: 1fr auto 4fr;
    grid-template-areas: "title value reason";
    grid-column-gap: ${({ theme }) => theme.spacings.m};
    line-height: ${({ theme }) => theme.spacings.xl};
    padding: ${({ theme }) => `${theme.spacings.xs} 0`};

    & > p {
      line-height: 1.5rem;
    }

    @media (max-width: ${({ theme }) => theme.utils.breakpoints.laptop}) {
      grid-template-columns: 1fr auto 3fr;
    }

    @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
      grid-template-columns: 1fr auto;
      grid-template-areas: "title value" "reason reason";

      & > p:last-of-type:not(:empty) {
        padding-top: ${({ theme }) => theme.spacings.xs};
      }
    }
  }

  & > div:first-of-type {
    padding-top: 0;
  }

  & > div:last-of-type {
    border-bottom: none;
    padding-bottom: 0;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    padding: 0;
  }
`;
const SleptValueWrapper = styled_components_1.default.div `
  margin-left: ${({ hasMargin }) => (hasMargin ? 6 : 0)}px;

  & > div {
    background-color: ${({ theme }) => theme.colors.silverLighten70};
    border-radius: ${({ theme }) => theme.utils.radius};
    height: unset;
    font-size: 0.875rem;
    line-height: 1rem;
    margin: 0;
    min-width: 1.5rem;
    max-width: 3rem;
    padding: 0.2rem 0.5rem;
    text-align: center;
    white-space: unset;
    width: unset;
  }
`;
//# sourceMappingURL=renderRows.js.map